import React, { useState, useEffect } from "react";
import { useOutletContext } from 'react-router-dom';
import RequestService from "../services/RequestService";
import { FaCircle } from "react-icons/fa";
import { parseISO, format, differenceInHours } from "date-fns";
import RequestDetailsModal from "./modals/RequestDetailsModal";
import SendToWarehouseModal from "./modals/SendToWarehouseModal"
import { FaLongArrowAltDown } from "react-icons/fa";
import SendToBackOfficeModal from './modals/SendToBackOfficeModal';
import { isSLAPassed, isSLANear } from "../utils/SLACalcs";
import { TiArrowBack } from "react-icons/ti";
import CancelModal from "./modals/CancelModal";
import StatusRequests from './../enums/StatusRequests';
import { startPolling } from "../utils/polling";

export default function Gestao() {

  const [requestList, setRequestList] = useState({ requests: [], totalPages: 1 });
  const [currentPageGestao, setCurrentPageGestao] = useState(1);
  const [requestDetailsModal, setRequestDetailsModal] = useState(false);
  const [requestOnDetailsModal, setRequestOnDetailsModal] = useState();
  const [sendToBackOfficeModal, setSendToBackOfficeModal] = useState(false);
  const [requestOnBackOfficeModal, setRequestOnBackOfficeModal] = useState();
  const [requestNroOnBackOfficeModal, setRequestNroOnBackOfficeModal] = useState();

  const [cancelModal, setCancelModal] = useState(false);
  const [requestOnCancelModal, setRequestOnCancelModal] = useState();

  //filters
  const [search, setSearch] = useState('');
  const [tempSearch, setTempSearch] = useState(''); // Estado temporário para o input
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  // const [status, setStatus] = useState('');

   const { user } = useOutletContext();

  useEffect(() => {
    
    // async function fetchRequests() {
    //   const status = '?status=GESTAO'
    //   const requestsNovas = await RequestService.getRequest(status);
    //   setRequestList(requestsNovas);
    // }

    // fetchRequests();

    // Função para buscar os requests
    const fetchRequests = async () => {
      const status = 'GESTAO';
      const params = new URLSearchParams();
      if (search) params.append('search', search);
      if (startDate) params.append('startDate', startDate);
      if (endDate) params.append('endDate', endDate);
      if (status) params.append('status', status);

      const queryString = params.toString();
      const requestsNovas = await RequestService.getRequest(`?${queryString}`, currentPageGestao, 10);

      setRequestList(requestsNovas);
    };

    // Chamada inicial
    fetchRequests();

    return startPolling(fetchRequests);

    }, [currentPageGestao, endDate, search, startDate, cancelModal, sendToBackOfficeModal, requestDetailsModal]);

  const handleRequestDetailsModal = async (ticketId) => {
    setRequestDetailsModal(true)
    setRequestOnDetailsModal(ticketId)
  };

  const handleBackOfficeModal = async (ticketId, requestNro) => {
    setSendToBackOfficeModal(true)
    setRequestOnBackOfficeModal(ticketId)
    setRequestNroOnBackOfficeModal(requestNro)
  };

  const handlePageChangeGestao = (newPage) => {
    if (newPage >= 1 && newPage <= requestList.totalPages) {
      setCurrentPageGestao(newPage);
    }
  };

  // ====== FILTER FUNCTIONS ====== 

  const clearFilters = () => {
    setSearch('');
    setTempSearch('');
    setStartDate('');
    setEndDate('');
    // setStatus('');
  };

  const handleSearchChange = (e) => {
    // setSearch(e.target.value);
    setTempSearch(e.target.value); // Atualiza o estado temporário
  };

  const handleSearchBlur = () => {
    setSearch(tempSearch); // Atualiza o estado principal quando o input perde o foco
    // console.log(tempSearch);
    setCurrentPageGestao(1);
  };

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
    // console.log(e.target.value)
    setCurrentPageGestao(1);
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
    // console.log(e.target.value)
    setCurrentPageGestao(1);
  };

  const renderFurtoVandalismoFlag = (request) => {
    if (!request?.isFurtoVandalismo) {
      return '-';
    }

    return (
      <div className="flex items-center justify-center gap-1 text-red-600 font-bold whitespace-nowrap">
        <span className="inline-block h-2.5 w-2.5 rounded-full bg-red-500"></span>
      </div>
    );
  };

  // ====== END FILTER FUNCTIONS ====== 

    const handleCancel = async (requestId) => {

      setCancelModal(true)
      setRequestOnCancelModal(requestId)
  
    }
  
    // const handleStatusChange = (e) => {
    //   setStatus(e.target.value);
    //   console.log(e.target.value)
    // };
  
    // const handleSubmit = (e) => {
    //   e.preventDefault();
    //   // Implement your search logic here
    //   console.log('Search:', search);
    //   console.log('Start Date:', startDate);
    //   console.log('End Date:', endDate);
    //   // console.log('Status:', status);
    // };


  return (
    <div className="flex w-full h-full justify-center items-center py-4 px-4 bg-gray-200">

      <div className="flex flex-col w-full h-full rounded-xl py-8 px-6 gap-12 bg-white">

        <div className="flex flex-col w-full h-full gap-2 border border-gray-800 border-opacity-40 rounded-xl p-2">
          <div className="flex items-center gap-2 w-full text-sm font-semibold ps-2 mt-2">
            <FaCircle
              color={StatusRequests["GESTAO"]?.cor}
              size={15}
            />
            GESTÃO
          </div>

          <div className="flex flex-col justify-between w-full h-full">
            <div className="flex flex-col gap-4">

              <div className="flex items-end w-full rounded-md gap-4 mt-2 text-[10px]">
                <div className="flex space-x-4 text-[12px]">
                  <div className="flex flex-col">
                    <label className="font-semibold ms-2">Pesquisar</label>
                    <input
                      type="text"
                      placeholder="Search"
                      value={tempSearch}  // Vincula o valor ao estado temporário
                      onChange={handleSearchChange}  // Atualiza o estado temporário em tempo real
                      onBlur={handleSearchBlur}  // Atualiza o estado principal ao perder o foco
                      className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                    />
                  </div>
                  <div className="flex flex-col">
                    <label className="font-semibold ms-2">Data Início</label>
                    <input
                      type="date"
                      placeholder="Start Date"
                      value={startDate}
                      onChange={handleStartDateChange}
                      className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                    />
                  </div>
                  <div className="flex flex-col">
                    <label className="font-semibold ms-2">Data Fim</label>
                    <input
                      type="date"
                      placeholder="End Date"
                      value={endDate}
                      onChange={handleEndDateChange}
                      className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                    />
                  </div>
                  {/* <div className="flex flex-col">
                  <label className="text-sm font-semibold">Status</label>
                  <select
                    value={status}
                    onChange={handleStatusChange}
                    className="border border-gray-300 rounded px-2 py-2"
                  >
                    <option value="">Select Status</option>
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </select>
                </div> */}
                </div>

                <div className="flex gap-2">
                  {/* <button onClick={handleSubmit} className="bg-zinc-800 hover:bg-zinc-700 text-white h-6 px-4 rounded-2xl w-40">
                  Buscar
                </button> */}
                  <button onClick={clearFilters} className="bg-zinc-800 hover:bg-zinc-700 text-white h-5 px-4 rounded-2xl w-40">
                    Limpar Filtros
                  </button>
                </div>
              </div>

              <div className="overflow-x-auto">
                <table className="min-w-full bg-white rounded-lg text-[10px]">
                  <thead className="bg-[#f87171]">
                    <tr>
                      <th className="py-2 px-4 border-b rounded-tl-lg">Status</th>
                      <th className="py-2 px-4 border-b">ID</th>
                      <th className="py-2 px-4 border-b">Criado em</th>
                      <th className="py-2 px-4 border-b">Cod Sap</th>
                      <th className="py-2 px-4 border-b">Furto/Vand.</th>
                      <th className="py-2 px-4 border-b">DRS Original</th>
                      <th className="py-2 px-4 border-b">DRS a Atender</th>
                      <th className="py-2 px-4 border-b">Qtd Solicitada</th>
                      <th className="py-2 px-4 border-b">Qtd à Atender</th>
                      <th className="py-2 px-4 border-b">Qtd Cortada</th>
                      <th className="py-2 px-4 border-b">Atendimento</th>
                      <th className="py-2 px-4 border-b">Técnico</th>
                      <th className="py-2 px-4 border-b">Observação</th>
                      <th className="py-2 px-4 border-b"><div className="flex justify-center items-center">Data SLA<FaLongArrowAltDown /></div></th>
                      <th className="py-2 px-4 border-b rounded-tr-lg">Ação</th>
                    </tr>
                  </thead>
                  <tbody>
                    {requestList.requests?.map((request, index) => (
                      <tr key={index} className={`border-b hover:bg-gray-100 ${isSLAPassed(request.slaDate) ? 'bg-red-50' : isSLANear(request.slaDate) ? 'bg-yellow-50' : ''}`}>
                        <td className="py-1 px-4">
                          <div className="flex justify-center items-center gap-2">
                            <FaCircle
                              color={"#f87171"}
                              size={15}
                            />
                            {request.status}
                          </div>
                        </td>
                        <td className="py-1 px-4 cursor-pointer underline font-bold" onClick={() => handleRequestDetailsModal(request._id)}>{request.idRequest}</td>
                        <td className="py-1 px-4">{format(parseISO(request.createdAt), 'dd/MM/yy HH:mm')}</td>
                        <td className="py-1 px-4 whitespace-nowrap">{request.codSap}</td>
                        <td className="py-1 px-4 text-center">{renderFurtoVandalismoFlag(request)}</td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.drsOriginal?.sigla}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.drsAtender?.sigla}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.quantidadeSolicitada}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.quantidadeAtender}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.quantidadeCortada}</div></td>
                        <td className="py-1 px-4">
                          <div className="flex justify-center items-center gap-2">
                            {["bbn-alta", "bbn-media"].includes(request.tipoAtendimento) ? (
                              <span className="text-black font-bold rounded-lg px-1 bg-yellow-300">
                                {request.tipoAtendimento.toUpperCase()}
                              </span>
                            ) : (
                              request.tipoAtendimento.toUpperCase()
                            )}
                          </div>
                        </td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.tecnico ? request.tecnico + "-" +request.telefone: request.user.name + "-" +request.user.phone}</div></td>
                        <td className="py-1 px-4">{request.ultimaObs}</td>
                        <td className={`py-1 px-4 ${isSLAPassed(request.slaDate) ? 'text-red-500 font-bold' : isSLANear(request.slaDate) ? 'text-yellow-600 font-bold' : ''} `}>
                          {request?.slaDate ? format(parseISO(request.slaDate), 'dd/MM/yy HH:mm') : ""}
                        </td>
                        <td className="py-1 px-4">
                          <div className="flex justify-start gap-2 h-5 text-[11px]">
                            {/* <button
                            className=" bg-sky-700 rounded-full px-2 py-1 text-white text-sm"
                            onClick={()=>handleAnswerRequest(request._id, request.idRequest)}
                          >
                            Atender
                          </button> */}
                            <button
                              className="flex items-center gap-1 bg-amber-400 rounded-full px-2 py-1 text-black"
                              onClick={() => handleBackOfficeModal(request._id, request.idRequest)}
                            >
                              <TiArrowBack />
                              Backoffice
                            </button>
                            {/* {(user.email === 'junior.silva@amerinode.com.br' || 
                              user.email === 'guilherme.alberto@amerinode.com.br' || 
                              user.email === 'jean.medeiros@amerinode.com.br' ||
                              user.email === 'renato.silva@amerinode.com.br') && */}
                              <button
                                className=" bg-neutral-300 rounded-full px-2 text-black"
                                onClick={() => handleCancel(request._id)}
                              >
                                Cancelar
                              </button>
                            {/* } */}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

            </div>

            {/* Pagination Controls */}
            <div className="flex justify-center items-center mt-4 gap-2 text-xs">
              <button
                onClick={() => handlePageChangeGestao(currentPageGestao - 1)}
                disabled={currentPageGestao === 1}
                className={`px-2 py-1 rounded-md ${currentPageGestao === 1 ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-500 text-white'}`}
              >
                {'<'}
              </button>

              {/* Botão para a primeira página */}
              {currentPageGestao > 2 && (
                <>
                  <button
                    onClick={() => handlePageChangeGestao(1)}
                    className="px-2 py-1 rounded-md bg-gray-300"
                  >
                    1
                  </button>
                  {currentPageGestao >= 3 && <span className="px-2 py-1">...</span>}
                </>
              )}

              {/* Botões ao redor da página atual */}
              {Array.from({ length: 3 }, (_, i) => {
                const page = currentPageGestao - 1 + i;
                if (page > 0 && page <= requestList.totalPages) {
                  return (
                    <button
                      key={page}
                      onClick={() => handlePageChangeGestao(page)}
                      className={`px-2 py-1 rounded-md ${page === currentPageGestao ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}
                    >
                      {page}
                    </button>
                  );
                }
                return null;
              })}

              {/* Botão para a última página */}
              {currentPageGestao < requestList.totalPages - 1 && (
                <>
                  {currentPageGestao < requestList.totalPages - 2 && <span className="px-2 py-1">...</span>}
                  <button
                    onClick={() => handlePageChangeGestao(requestList.totalPages)}
                    className="px-2 py-1 rounded-md bg-gray-300"
                  >
                    {requestList.totalPages}
                  </button>
                </>
              )}

              <button
                onClick={() => handlePageChangeGestao(currentPageGestao + 1)}
                disabled={currentPageGestao === requestList.totalPages}
                className={`px-2 py-1 rounded-md ${currentPageGestao === requestList.totalPages ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-500 text-white'}`}
              >
                {'>'}
              </button>
            </div>

          </div>
        </div>

      </div>

      {requestOnDetailsModal && 
        <div className="absolute">
          <RequestDetailsModal
            isModalOpen={requestDetailsModal}
            setModalOpen={() => {
              setRequestDetailsModal(!requestDetailsModal);
            }}
            requestId={requestOnDetailsModal}
            isGestao={true}
            // setTicketCb={setTicket}
          ></RequestDetailsModal>
        </div>
      }

      { requestOnBackOfficeModal && 
      <div className="absolute">
        <SendToBackOfficeModal
          isModalOpen={sendToBackOfficeModal}
          setModalOpen={() => {
            setSendToBackOfficeModal(!sendToBackOfficeModal);
          }}
          requestId={requestOnBackOfficeModal}
          requestNro={requestNroOnBackOfficeModal}
          isGestao={true}
          // setTicketCb={setTicket}
        ></SendToBackOfficeModal>
      </div>
      }

      { requestOnCancelModal && 
      <div className="absolute">
        <CancelModal
          isModalOpen={cancelModal}
          setModalOpen={() => {
            setCancelModal(!cancelModal);
          }}
          requestId={requestOnCancelModal}
          isGestao={true}
          // setTicketCb={setTicket}
        ></CancelModal>
      </div>
      }


    </div>
  )
}
